var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBot = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02033 15.0952C7.33951 15.3091 8.65869 15.3091 9.97787 15.0952C11.4062 14.83 13.0641 13.1008 13.5945 11.5588C14.2608 9.38613 14.624 7.30262 14.5259 5.33053C14.3945 3.73949 12.3821 1.56292 10.6709 1.09444C8.95973 0.625972 7.03973 0.624867 5.32508 1.09444C3.66497 1.54903 1.60152 3.73949 1.47227 5.33053C1.46864 5.40358 1.46564 5.47678 1.46327 5.55012C1.27008 5.64906 1.08825 5.75243 0.91864 5.85984C0.521545 6.11131 0.327137 6.57421 0.366263 7.04261C0.435248 7.86846 0.560253 8.70827 0.736373 9.56141C0.816954 9.95176 1.05337 10.2952 1.40673 10.4796C1.65095 10.607 1.91384 10.7273 2.19355 10.8396C2.25974 11.0782 2.32987 11.3179 2.40372 11.5588C2.93407 13.103 4.58973 14.83 6.02033 15.0952Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5941 10.4796C14.349 10.6075 14.0851 10.7281 13.8043 10.8408C14.3135 9.00562 14.5897 7.23701 14.535 5.54879C14.7291 5.64814 14.9118 5.75195 15.0822 5.85984C15.4793 6.11131 15.6737 6.57421 15.6346 7.04261C15.5656 7.86846 15.4406 8.70827 15.2644 9.56141C15.1839 9.95176 14.9474 10.2952 14.5941 10.4796Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4414 10.0872C13.3695 10.3767 13.1626 10.6147 12.8818 10.7151C11.5373 11.1957 9.84247 11.4827 8.00021 11.4827C6.15677 11.4827 4.46093 11.1954 3.11609 10.7142C2.83539 10.6137 2.62854 10.3757 2.55673 10.0864C2.21574 8.71239 2.01509 7.37904 2.00006 6.09294C1.99603 5.74799 2.19184 5.43182 2.50762 5.29295C3.92978 4.66754 5.86542 4.28271 8.00021 4.28271C10.1338 4.28271 12.0685 4.66712 13.4904 5.2919C13.8063 5.43071 14.0023 5.74693 13.9983 6.09196C13.9833 7.37864 13.7826 8.71259 13.4414 10.0872Z",
    fill: "url(#paint0_radial_10065_34224)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.62028C4 9.05381 4.40159 9.40313 4.9 9.40313C5.39841 9.40313 5.8 9.05381 5.8 8.62028V6.98597C5.8 6.55244 5.39841 6.20312 4.9 6.20312C4.40159 6.20312 4 6.55244 4 6.98597V8.62028Z",
    fill: "url(#paint1_radial_10065_34224)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1998 8.62028C10.1998 9.05381 10.6014 9.40313 11.0998 9.40313C11.5982 9.40313 11.9998 9.05381 11.9998 8.62028V6.98597C11.9998 6.55244 11.5982 6.20312 11.0998 6.20312C10.6014 6.20312 10.1998 6.55244 10.1998 6.98597V8.62028Z",
    fill: "url(#paint2_radial_10065_34224)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10065_34224",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.99948 7.88287) scale(6.36597 3.58838)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#035388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01253D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10065_34224",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.02802 6.24872) rotate(90) scale(3.1875 37.4323)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54E0EF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_10065_34224",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.02802 6.24872) rotate(90) scale(3.1875 37.4323)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54E0EF"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Bot.23f354762a053cf0e2aa688d3c97a573.svg";